const decimalRegex = /^(?:-?\d+)?(?:\.\d+)?/

const afterDecimalRegex = /^(?:-?\d+)?(?:\.\d+)?(.*)/

module.exports = function parseQuantity (quantity) {
  const decimalMatches = decimalRegex.exec(quantity)

  if (!decimalMatches) return null

  const [ value ] = decimalMatches

  if (!value) return null

  const unitMatches = afterDecimalRegex.exec(quantity)

  if (!unitMatches) return null

  const [ , unit ] = unitMatches

  if (!unit) return null

  return [ Number(value), unit ]
}
